const { invert } = require('lodash');

const contractConstant = {
  headerMapping: {
    'Type*': 'contract_type',
    'Source*': 'source',
    'Destination*': 'destination',
    'Vehicle Name*': 'vehicle_type',
     Distance: 'distance',
    'Transporter Reference ID*': 'transporter_ref_id',
    'Transporter Name': 'transporter_name',
    'Transit Days*': 'transit_days',
    'Freight Rate*': 'freight_rate',
    'Freight Unit*': 'freight_unit',
    'Valid From*': 'valid_from',
    'Valid To*': 'valid_to',
    'Minimum Rate': 'minimum_rate',
    'Multiplying Factor': 'multiplying_factor',
    'Detention Group': 'detention_group',
    Exclude: 'route_exclude',
    'Trip Count': 'trip_count',
  },
  nonMandatoryHeaders: {
    'Product Category': 'product_category',
    'Fixed Rate': 'fixed_rate',
    'ODA Rate': 'oda_rate',
    'Oda Unit': 'oda_unit',
    'Minimum ODA': 'minimum_oda',
    'Drop Point Charges': 'point_charges',
    'Pickup Point Charges': 'pickup_point_charges',
    'Is Dedicated': 'is_dedicated',
    'Truck Count': 'truck_count',
    'Min Slab Range': 'min_slab_range',
    'Max Slab Range': 'max_slab_range',
    'Additional Charge Percentage': 'additional_charge_percentage',
    'Hilly Region Addition Percentage': 'hilly_region_addition_percentage',
    'Is Round Trip Eligible': 'is_round_trip_eligible',
    'Return Freight Rate': 'return_freight_rate',
    Via: 'via',
    'Indent Cancellation Charge': 'indent_cancellation_charge',
    'Flat Variable Charge': 'flat_variable_charge',
    'Is Owned': 'is_owned',
  },
  dieselPegHeaders: {
    'BFR Label': 'bdr_label',
  },
  movementRateHeaders: {
    Movement: 'charge_label',
  },
  lastMileHeaders: {
    'Return Pickup Point Charges': 'return_pickup_point_charges',
    'Return Drop Point Charges': 'return_drop_point_charges',
    'RTO Charges': 'rto_charges',
    'Minimum RTO Charges': 'minimum_rto_charges'
  },
  vehicleExcludeHeaderMapping: {
    Source: 'source',
    Destination: 'destination',
    'Vehicle Name': 'vehicle_type',
    Exclude: 'route_exclude',
    'Trip Count': 'trip_count',
  },
  defaultProductCategory: 'default',
  freight_unit: {
    1: 'per_trip',
    2: 'per_ton',
    3: 'per_kg',
    4: 'per_cft',
    5: 'per_package',
    6: 'per_case',
    7: 'per_box',
    8: 'per_km',
    9: 'percentage',
  },
  status: { 1: 'accepted', 2: 'rejected', 3: 'pending', 4: 'expired', 5: 'future' },
  delivery_type: { 1: 'FTL', 2: 'PTL' },
  contract_type: {
    1: 'city',
    2: 'state',
    3: 'region',
    4: 'point',
    5: 'city-point',
    6: 'city-state',
    7: 'city-region',
    8: 'state-point',
    9: 'state-city',
    10: 'state-region',
    11: 'region-point',
    12: 'region-city',
    13: 'region-state',
    14: 'point-city',
    15: 'point-state',
    16: 'point-region',
    17: 'pincode-point',
    18: 'pincode-city',
    19: 'pincode-state',
    20: 'pincode-region',
    21: 'point-pincode',
    22: 'city-pincode',
    23: 'state-pincode',
    24: 'region-pincode',
    25: 'pincode',
    26: 'route',
  },
  movement: { 1: 'Secondary', 2: 'Primary', 3: 'Vendor', 4: 'Return' },
  freight_unit_possibilities: {
    kg: 'per_kg',
    per_kg: 'per_kg',
    'per kg': 'per_kg',
    ton: 'per_ton',
    tonne: 'per_ton',
    per_tonne: 'per_ton',
    per_ton: 'per_ton',
    'per ton': 'per_ton',
    'per tonne': 'per_ton',
    cft: 'per_cft',
    per_cft: 'per_cft',
    'per cft': 'per_cft',
    package: 'per_package',
    per_package: 'per_package',
    packages: 'per_package',
    'per package': 'per_package',
    rate: 'per_package',
    trip: 'per_trip',
    per_trip: 'per_trip',
    'per trip': 'per_trip',
    case: 'per_case',
    per_case: 'per_case',
    'per case': 'per_case',
    km: 'per_km',
    'per km': 'per_km',
    per_km: 'per_km',
    box: 'per_box',
    per_box: 'per_box',
    'per box': 'per_box',
    'percentage': 'percentage'
  },
  defaultMovement: 'default',
  supportedFormats: ['MM/DD/YYYY', 'MM-DD-YYYY', 'MM/DD/YY', 'MM-DD-YY', 'YYYY-MM-DD',
  'YYYY/MM/DD', 'YYYY-MM-DD HH:mm:ss', 'YYYY/MM/DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ss+hh:mm', 'DD-MMM-YYYY'],
};

const invertedStatus = invert(contractConstant.status);
contractConstant.STATUS = Object.keys(invertedStatus).reduce((acc, key) => {
  acc[key.toUpperCase()] = parseInt(invertedStatus[key], 10);
  return acc;
}, {});

const invertedDeliveryType = invert(contractConstant.delivery_type);
contractConstant.DELIVERY_TYPE = Object.keys(invertedDeliveryType).reduce((acc, key) => {
  acc[key] = parseInt(invertedDeliveryType[key], 10);
  return acc;
}, {});

contractConstant.SOURCE_TYPE = Object.keys(contractConstant.contract_type).reduce((acc, key) => {
  acc[key] = contractConstant.contract_type[key].split('-')[0];
  return acc;
}, {});

const contractType = {
  CITY: 1,
  STATE: 2,
  REGION: 3,
  POINT: 4,
  POINTCITY: 14,
  PINCODE: 25,
  ROUTE: 26,
};

const contractTypeName = {
  1: 'city',
  2: 'state',
  3: 'region',
  4: 'point',
  5: 'city-point',
  6: 'city-state',
  7: 'city-region',
  8: 'state-point',
  9: 'state-city',
  10: 'state-region',
  11: 'region-point',
  12: 'region-city',
  13: 'region-state',
  14: 'point-city',
  15: 'point-state',
  16: 'point-region',
  17: 'pincode-point',
  18: 'pincode-city',
  19: 'pincode-state',
  20: 'pincode-region',
  21: 'point-pincode',
  22: 'city-pincode',
  23: 'state-pincode',
  24: 'region-pincode',
  25: 'pincode',
  26: 'route',
};

const contractTypeNameMap = {
  city: 1,
  state: 2,
  region: 3,
  point: 4,
  'city-point': 5,
  'city-state': 6,
  'city-region': 7,
  'state-point': 8,
  'state-city': 9,
  'state-region': 10,
  'region-point': 11,
  'region-city': 12,
  'region-state': 13,
  'point-city': 14,
  'point-state': 15,
  'point-region': 16,
  'pincode-point': 17,
  'pincode-city': 18,
  'pincode-state': 19,
  'pincode-region': 20,
  'point-pincode': 21,
  'city-pincode': 22,
  'state-pincode': 23,
  'region-pincode': 24,
  pincode: 25,
  route: 26,
};

const freightUnitType = {
  PER_TRIP: 1,
  PER_TON: 2,
  PER_KG: 3,
  PER_CFT: 4,
  PER_PACKAGE: 5,
  PER_CASE: 6,
  PER_BOX: 7,
  PER_KM: 8,
  PERCENTAGE: 9,
};

const defaultTripCount = 50;

const contractTypes = {
  MOVEMENT: 'movement',
};

const contractChargeType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  VENDOR: 'inward',
  RETURNS: 'returns',
  DEFAULT: 'default',
};

const CONTRACT_DATE_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss';

const chargeLevelKey = {
  ROUTES: 'routes',
};

module.exports = {
  contractType,
  defaultTripCount,
  contractTypeName,
  freightUnitType,
  contractTypeNameMap,
  contractTypes,
  contractChargeType,
  CONTRACT_DATE_FORMAT,
  contractConstant,
  chargeLevelKey,
};
